var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('layout-app-bar'),_c('layout-drawer'),_c('layout-view'),_c('layout-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }